enum UserType {
    ActiveDirectory = "ActiveDirectory",
    External = "External"
}

export default UserType;